import { SITE } from '@/app/constants';

/**
 * 获取资源 url
 * @param uri 有水印资源 url
 * @param noMarkUri 无水印资源 url
 * @returns 资源 url，如果非中国大陆地区，且有无水印资源 url，则使用无水印资源 url
 */
export const getResourceUrl = ({ uri, noMarkUri }: { uri: string; noMarkUri: string }) => {
  return SITE !== 'china' && noMarkUri ? noMarkUri : uri;
};
